module.exports = __webpack_public_path__ + "img/whiteCross.d5c579ad.png";